import styled from 'styled-components'

const TopSectionStyle = styled.div.attrs({})`
    margin-top:var(--sp4x);

    .left {
        max-width:61%;
        width: 100%;
        margin-right:var(--sp6x);

        .title {
            margin-bottom: var(--sp4x);
            max-width:var(--sp80x);
            position: relative;

            span {
                margin-right: var(--sp2x);
            }

            .shape {
                position: relative;
                
                &:before {
                    content: '';
                    position: absolute;
                    top: -8px;
                    right: 13px;
                    background-image: url('/images/home/yellowVector.svg');
                    width: 200px;
                    height: 82px;
                    background-repeat: no-repeat;
                    z-index: -1;
                    background-size: contain;
                }
            }
        }

        .tag-btns {
            & > div {
                margin-top:var(--spSize);
                margin-right:var(--spSize);
            }
        }
    }

    .imageCont {
        width: 26%;
        padding-top: 22%;

        img {
            object-fit:contain;
        }
    }

    @media only screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}){
        margin-top:var(--spSize);
        flex-direction: column;
        
        .left {
            flex-direction: column;
            max-width:unset;
            width: 100%;
            margin-right:0;

            .title {
                margin-bottom: var(--sp3x);
                max-width:unset;
                position: relative;

                span {
                    margin-right: var(--spSize);
                }
                
                .shape {
                    &:before {
                        top: -5px;
                        right: 5px;
                        width: 100px;
                        height: 42px;
                    }
                }
            }
        }

        .imageCont {
            display: none;
        }
    }
`
export default TopSectionStyle
